'use strict';

import React from 'react';
import { useState, useEffect, useContext, useMemo } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import AppContext from '../AppContext';

import Loader from '../helper/Loader';


function SchoolBusiness() {
    const { request } = useRequest();
    const [business, setBusiness] = useState(false);
    const [isBlocked, setIsBlocked] = useState(false);
    const { Categories, Salutations } = useContext(AppContext);
    const [category, setCategory] = useState([]);

    const [contact, setContact] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let pathname = location.pathname.split("/");
                let id = pathname[pathname.length - 1];
                let result = await request("/School/GetBusiness", { id: id});
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    setBusiness(json.business);
                    setIsBlocked(json.blocked);
                    setContact(json.contact);
                    let cats = [];
                    for (var i = 0; i < json.categories.length; i++) {
                        let found = Categories.find(m => m.CategoryID == json.categories[i]);
                        if (found) {
                            cats.push({ value: found.CategoryID, label: found.Description });
                        }
                    }     
                    setCategory(cats);
                }
            }
            catch (ex) {
                console.error(ex);
                toast.error("Es ist ein Fehler aufgetreten.");
            }
        };
        fetchData();
    }, []);

    const confirmBlock = async () => {
        try {
            let pathname = location.pathname.split("/");
            let id = pathname[pathname.length - 1];
            let result = await request("/School/BlockBusiness", { businessId: id });
            
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Das Unternehmen wurde gesperrt.");
                setIsBlocked(!isBlocked);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const confirmUnblock = async () => {
        try {
            let pathname = location.pathname.split("/");
            let id = pathname[pathname.length - 1];
            let result = await request("/School/UnblockBusiness", { businessId: id });

            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Die Sperre des Unternehmens wurde aufgehoben.");
                setIsBlocked(!isBlocked);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const sortedCategories = useMemo(() => Categories.sort((a, b) => {
        const nameA = a.Description.toUpperCase();
        const nameB = b.Description.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
    }), [Categories]);

    if (business === false) return <Loader />

    return (
        <>
            <h4 class="fw-bold">Unternehmen</h4>
            <Row>
                <Col xs="12" lg="6">
                    <Form.Group className="form-group" controlId="organisationName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control placeholder="" name="organisationName" value={business.OrganisationName} disabled={true} />
                    </Form.Group>
                </Col>
                <Col xs="12" lg="6">
                    <Form.Group className="form-group" controlId="category">
                        <Form.Label>Betriebskategorie</Form.Label>
                        <Select isMulti name="Category" options={sortedCategories} classNamePrefix="bv-select" className="bv-select" placeholder="Bitte ausw&auml;hlen" value={category} isDisabled={true} />
                    </Form.Group>
                </Col>
            </Row>
            

           

            <Row className="form-group">
                <Col sm="12" md="6">
                    <Form.Group controlId="street">
                        <Form.Label>Straße</Form.Label>
                        <Form.Control placeholder="" name="street" value={business.Street} disabled={true} />
                    </Form.Group>
                </Col>
                <Col sm="12" md="6">
                    <Form.Group controlId="houseNo">
                        <Form.Label>Hausnummer</Form.Label>
                        <Form.Control placeholder="" name="houseNo" value={business.HouseNo} disabled={true} />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="form-group">
                <Col sm="12" md="6">
                    <Form.Group controlId="postCode">
                        <Form.Label>Postleitzahl</Form.Label>
                        <Form.Control placeholder="" name="postCode" value={business.PostCode} disabled={true} />
                    </Form.Group>
                </Col>
                <Col sm="12" md="6">
                    <Form.Group controlId="city">
                        <Form.Label>Ort</Form.Label>
                        <Form.Control placeholder="" name="city" value={business.City} disabled={true} />
                    </Form.Group>
                </Col>
            </Row>

         

            {contact && (
                <>
                    <h3>Ansprechpartner</h3>
                    <Row className="form-group">
                        <Col sm="12" md="6">
                            <Form.Group controlId="salutation">
                                <Form.Label>Ansprechpartner Anrede</Form.Label>
                                <Form.Select className="form-control" disabled={true} name="salutation" value={contact.SalutationID}>
                                    {Salutations.map((option) => {
                                        return (
                                            <option key={option.SalutationID} value={option.SalutationID}>
                                                {option.Description}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col sm="12" md="6">
                            <Form.Group controlId="title">
                                <Form.Label>Titel</Form.Label>
                                <Form.Control placeholder="" name="title" value={contact.Title || ""} disabled={true} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-group">
                        <Col sm="12" md="6">
                            <Form.Group controlId="firstname">
                                <Form.Label>Vorname</Form.Label>
                                <Form.Control placeholder="" name="postCode" value={contact.FirstName} disabled={true} />
                            </Form.Group>
                        </Col>
                        <Col sm="12" md="6">
                            <Form.Group controlId="lastname">
                                <Form.Label>Nachname</Form.Label>
                                <Form.Control placeholder="" name="lastname" value={contact.LastName} disabled={true} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="form-group">
                        <Col sm="12" md="6">
                            <Form.Group controlId="email">
                                <Form.Label>E-Mail-Adresse</Form.Label>
                                <Form.Control placeholder="" name="email" value={contact.Email} disabled={true} />
                            </Form.Group>
                        </Col>
                        <Col sm="12" md="6">
                            <Form.Group controlId="phone">
                                <Form.Label>Telefon</Form.Label>
                                <Form.Control placeholder="" name="phone" value={contact.PhoneNo} disabled={true} />
                            </Form.Group>
                        </Col>
                    </Row>
                </>
            )}

            <Row className="form-group">
                <Col sm="12" className="text-end">
                    {!isBlocked && <Button variant="danger" type="button" onClick={() => confirmBlock()}><i className="fa-solid fa-lock me-2"></i>Unternehmen sperren</Button>}
                    {isBlocked && <Button variant="danger" type="button" onClick={() => confirmUnblock()}><i className="fa-solid fa-unlock me-2"></i>Unternehmenssperre aufheben</Button>}
                </Col>
            </Row>
        </>
    );
}

export default SchoolBusiness;